import type { LoggerInterface } from "@interfaces/LoggerInterface";

import type { SelectValueParamsWithoutSchema } from "../../types";

class ParseFromJsonStrategy {
    constructor(private readonly logger: LoggerInterface) {}

    private parse(selector: string): unknown | null {
        let parsedJson = null;
        const scriptElement = document.querySelector(selector);

        if (!scriptElement) {
            this.logger.error(
                `ParseFromJsonStrategy script element by selector (${selector}) not found`
            );
        } else {
            try {
                parsedJson = JSON.parse(
                    scriptElement.textContent || ""
                ) as unknown;
            } catch (error: unknown) {
                this.logger.error(
                    "ParseFromJsonStrategy json parse error",
                    error
                );
            }
        }

        return parsedJson;
    }

    public getValue({
        namespace,
        key,
    }: SelectValueParamsWithoutSchema): Promise<unknown | null> {
        return Promise.resolve(this.parse(`#${namespace}\\:${key}`));
    }
}

export default ParseFromJsonStrategy;
